import React from 'react'
import { MessageCircle } from 'lucide-react'

const FloatingAssistantButton = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className="fixed bottom-6 right-6 z-40 flex items-center gap-2 px-4 py-3 rounded-full bg-gold text-ink shadow-lg shadow-black/40 hover:bg-gold-light transition-all hover:scale-[1.02]"
    title="Open Style AI Assistant"
    aria-label="Open Style AI Assistant"
  >
    <MessageCircle className="w-5 h-5" />
    <span className="text-sm font-semibold hidden sm:inline">Assistant</span>
  </button>
)

export default FloatingAssistantButton
